<template>
    <section id="confirm-email-reg">
        <b-modal @hide="onHide" id="email-confirm" ref="emailConfirm" hide-header hide-footer centered>
            <div class="email-confirm mx-auto d-flex justify-content-center align-items-center position-relative">
                <button 
                    @click="$store.commit('TOGGLE_MODAL', ['confirm-reg', false])" 
                    id="modal-close"
                    aria-label="Close" 
                    class="close pr-2">
                        <CloseCross />
                </button>
                <div class="modal-container-wrap">
                    <div class="text-center">
                        <p class="p3b c22">Check your inbox!</p>
                        <p class="c23 p1n mb-0 mt-4">Keep an eye on your inbox. </p>
                        <p class="c23 p1n mb-0">We just sent you the instructions. Follow</p>
                        <p class="c23 p1n mb-0">them and you are all set.</p>
                    </div>
                    <button 
                        @click="backToHome" 
                        id="check-your-inbox"
                        class="c16 p2b phiolet_button mt-5">
                            Check Your Inbox
                    </button>
                </div>
            </div>
        </b-modal>
    </section>
</template>

<script>
    import {
        GoogleIcon,
        CloseCross
    } from '../components/Icons'
    export default {
        name: 'EmailConfirmReg',
        components: {
            GoogleIcon,
            CloseCross
        },
        mounted: function() {
            this.$bvModal.show(`email-confirm`)
        },
        methods: {
            onHide: function(evt) {
                setTimeout(() => {
                    this.$store.commit('TOGGLE_MODAL', ['confirm-reg', false])
                }, 0)
            },
            backToHome: function () {
                this.$store.commit('TOGGLE_MODAL', ['confirm-reg', false]);
            }

        }
    }
</script>

<style scoped lang="scss">
    div.email-confirm {
        width: 450px;
        height: 325px;
        background: #FFFFFF;
        box-shadow: 0px 18px 23px rgba(0, 0, 0, 0.05);
        border-radius: 5px;

        @media screen and (max-width: 767px) {
            width: 100%
        }

        div.modal-container-wrap {
            width: 325px;
            height: 213px;

            @media screen and (max-width: 767px) {
                width: 270px
            }

            button {
                width: 100%;
                height: 48px;

                &:first-child {
                    background: #F4F4F4;
                    border-radius: 5px;
                    transition: all 0.2s ease;

                    &:hover {
                        box-shadow: 0px 4px 8px #858585;
                    }
                }
            }
        }
    }
</style>